import { useSession } from "@/Recoil/Session/Session";
import { useRoles } from "@/Recoil/Topik/Roles";
import './RoleSection.scss';

const ROLE_LABELS: Record<string, string> = {
    admin:    '관리자',
    manager:  '매니저',
    lecturer: '강의자',
    student:  '학생',
};

const RoleSection = () => {
    const { session } = useSession();
    const { roles } = useRoles();

    const userRole = roles[session.email];

    const roleLabel = userRole ? ROLE_LABELS[userRole.role] ?? userRole.role : '권한 없음';

    return (
        <div className="RoleSection">
            <div className="RoleInfo">
                <div
                    className="ProfileImage"
                    style={session.image ? { backgroundImage: `url(${session.image})`, backgroundSize: 'cover' } : undefined}
                />
                <div className="RoleDetails">
                    <span className="RoleBadge">{roleLabel}</span>
                    <p className="RoleEmail">{session.email}</p>
                </div>
            </div>
        </div>
    );
};

export default RoleSection;